import { Component, computed } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsMergeDto, SettingsService } from '@artemis-software/wr-api';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss'],
})
export class SettingsPageComponent {

  isEditing = false;
  form?: FormGroup;
  saving$ = new BehaviorSubject(false);

  canEdit = computed(() => this.currentUserService.hasPrivilege('editWeights'));

  constructor(
    private readonly settingsService: SettingsService,
    private readonly currentUserService: CurrentUserService
  ) {
    this.settingsService.getSettings().subscribe((settings) => {
      this.form = new FormGroup({
        id: new FormControl(settings?.id),
        conditionThresholds: new FormControl(settings?.conditionThresholds),
        inspectionIntervals: new FormGroup({
          norm1300IntervalMonths: new FormControl(settings?.inspectionIntervals?.norm1300IntervalMonths, [
            Validators.required,
            Validators.min(1),
          ]),
          norm1301IntervalMonths: new FormControl(settings?.inspectionIntervals?.norm1301IntervalMonths, [
            Validators.required,
            Validators.min(1),
          ]),
        }),
      });
      this.form.disable();
    });
  }

  onEdit(): void {
    this.isEditing = true;
    this.form?.enable();
  }

  async submit(): Promise<void> {
    this.form?.markAllAsTouched();
    if (this.form?.invalid) return;

    this.saving$.next(true);
    const settingsMergeDto: SettingsMergeDto = {
      ...this.form?.value,
    };
    try {
      await firstValueFrom(this.settingsService.merge(settingsMergeDto));
    } catch (error) {
      console.error(error);
    } finally {
      this.saving$.next(false);
      this.isEditing = false;
      this.form?.disable();
    }

  }
}
